export default function Footer() {
  const footerLinks = [
    {
      title: '热门分类',
      links: [
        { label: '电视剧全集', href: '#index' },
        { label: '电影大全', href: '#index' },
        { label: '热播剧集', href: '#media' },
        { label: '最新电影', href: '#media' },
        { label: '综艺节目', href: '#index' },
      ],
    },
    {
      title: '快捷入口',
      links: [
        { label: '热播榜单', href: '#ranking' },
        { label: '最新更新', href: '#updates' },
        { label: '热门话题', href: '#topics' },
        { label: '常见问题', href: '#faq' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '联系我们', href: '#contact' },
        { label: '移动端', href: '#app' },
      ],
    },
  ];

  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="font-heading text-2xl text-accent-400 whitespace-nowrap">
              棒棒TV
            </span>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              棒棒TV汇集电视剧全集、电影大全，最新热播剧集和电影，免费在线观看，高清不卡顿，流畅播放，随时随地畅享精彩影视。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                      className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-700/30">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <h4 className="text-sm text-background-50/60">
              合作伙伴
            </h4>
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 棒棒TV 版权所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}